import {
  AccommodationStatus,
  AccommodationStatusWithDecisionByLoginNeeded,
} from 'src/store/placementDetailsPageSlice/types';
import DecisionByLoginEntry from './statusUpdateForms/decisionByLoginEntry';
import DlsReferralFormEntry from './statusUpdateForms/dlsReferralFormEntry';
import Modal from '@amzn/meridian/modal';
import React, { useState } from 'react';
import { setIsUpdateStatusModalOpen } from 'src/store/placementDetailsPageSlice/placementDetailsPageSlice';
import StatusSelection from './statusUpdateForms/statusSelection';
import { UpdateStatusProgress } from './constants';
import { useAppDispatch, useAppSelector } from 'src/store/store';

const UpdatePlacementStatusModal = () => {
  const dispatch = useAppDispatch();
  const { isUpdateStatusModalOpen } = useAppSelector((state) => state.placementDetailsPage);
  return (
    <Modal
      title={'Update Status'}
      open={isUpdateStatusModalOpen}
      onClose={() => dispatch(setIsUpdateStatusModalOpen(false))}
      closeLabel="Close"
      aria-describedby="modal-description"
      width="416px"
    >
      <UpdatePlacementStatusModalContent />
    </Modal>
  );
};

// Must store local state in child component of Modal because closed modals are still on the DOM but their children are not.
// This provides a predictable local state lifecycle (read: clears when modal is closed)
const UpdatePlacementStatusModalContent = () => {
  const {
    accommodationStatus,
    placementDetails: { accommodationStatus: currentPlacementStatus },
  } = useAppSelector((state) => state.placementDetailsPage);

  const initialStatus = accommodationStatus?.find((val) => currentPlacementStatus?.status == val.status);
  const [selectedStatus, setSelectedStatus] = useState<
    AccommodationStatus | AccommodationStatusWithDecisionByLoginNeeded | undefined
  >(initialStatus);
  const [currentProgress, setProgress] = useState<UpdateStatusProgress>(UpdateStatusProgress.StatusSelection);

  if (currentProgress == UpdateStatusProgress.StatusSelection || !selectedStatus) {
    return <StatusSelection {...{ selectedStatus, setSelectedStatus, setProgress }} />;
  } else if (currentProgress == UpdateStatusProgress.DecisionByLoginEntry) {
    return <DecisionByLoginEntry {...{ selectedStatus, setProgress }} />;
  } else if (currentProgress == UpdateStatusProgress.DlsReferralFormEntry) {
    // collects info for a single status type and updates using its own API endpoint. selectedStatus is inferred implicitly
    return <DlsReferralFormEntry setProgress={setProgress} />;
  } else {
    return <></>;
  }
};

export default UpdatePlacementStatusModal;
